(() => {
  document.querySelectorAll('.bsb-tb__marquee').forEach((marquee) => {
    if (marquee.dataset.bsbTbInitialized) return;
    marquee.dataset.bsbTbInitialized = 'true';

    const track = marquee.querySelector('.bsb-tb__marquee-track');
    const pauseBtn = marquee.querySelector('.bsb-pause-btn');
    if (!track || !pauseBtn) return;

    const iconPlay = pauseBtn.querySelector('.bsb-pause-btn__icon--play');
    const iconPause = pauseBtn.querySelector('.bsb-pause-btn__icon--pause');

    pauseBtn.addEventListener('click', () => {
      const paused = track.classList.toggle('is-paused');
      pauseBtn.setAttribute('aria-label', paused ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
      pauseBtn.setAttribute('aria-pressed', String(paused));
      paused ? iconPlay.removeAttribute('hidden') : iconPlay.setAttribute('hidden', '');
      paused ? iconPause.setAttribute('hidden', '') : iconPause.removeAttribute('hidden');
    });
  });
})();
